import React, { Fragment } from 'react'
import { Intro, ClickAndReveal, Voiceover } from 'cvs-core'
import image from '../../assets/images/U1-T1-2.svg'
import img1 from '../../assets/images/U1-T1-2a.svg'
import img2 from '../../assets/images/U1-T1-2b.svg'
import img3 from '../../assets/images/U1-T1-2c.svg'
import voAudio from '../../assets/vo/Prepare-risks-of-vaping-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'In this module, you will learn more about the risks of vaping or using e-cigarettes. Click each hotspot below to explore what you will learn.',
}

const data = [
  {
    x: 10,
    y: 10,
    name: 'Teens at Risk',
    modal: {
      title: 'Teens at Risk',
      text: (
        <p>
          Teens are especially susceptible to the negative effects of
          vaping/using e-cigarettes because their brains are still developing.
        </p>
      ),
      image: img1,
      imageText: 'Teens at Risk',
    },
  },
  {
    x: 55,
    y: 50,
    name: 'Toxins',
    modal: {
      title: 'Toxins',
      text: (
        <p>
          Chemicals in the aerosols you vape carry toxins that get delivered all
          over your body.
        </p>
      ),
      image: img2,
      imageText: 'Toxins',
    },
  },
  {
    x: 80,
    y: 55,
    name: 'Social Consequences',
    modal: {
      title: 'Social Consequences',
      text: (
        <p>
          Besides being bad for your body, there are many social consequences
          from vaping, like: getting kicked off the team or club, losing
          friends, disappointing your family, and even suspension or legal
          problems.
        </p>
      ),
      image: img3,
      imageText: 'Social Consequences',
    },
  },
]

export default {
  title: 'Risks of Vaping',
  path: '/prepare/risks-of-vaping',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Risks of Vaping"
        lead="In this module, you will learn more about the risks of vaping/using e-cigarettes. Click each hotspot below to explore what you will learn."
      />
      <ClickAndReveal
        backgroundImage={image}
        backgroundImageText="Background Placeholder"
        data={data}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/RisksOfVaping.js